export default {
  'user.phonenumber.label': "Laharan'ny finday",
  'user.email.label': 'Mailaka',
  'user.editor.lastname.min.message':
    "Ny solon'anarana dia tokony hahitana soratra miisa 3 farafahakeliny.",
  'user.editor.lastname.required.message':
    "Tsy maintsy mampiditra solon'anarana ianao",
  'user.error.notfound.label': 'Olana: tsy fantatra io olona io!',
};
